export const ATTACK_VECTOR = [
  { label: 'Network (N)', value: 'N', score: 0.85 },
  { label: 'Adjacent (A)', value: 'A', score: 0.62 },
  { label: 'Local (L)', value: 'L', score: 0.55 },
  { label: 'Physical (P)', value: 'P', score: 0.2 },
] as const;

export const ATTACK_COMPLEXITY = [
  { label: 'Low (L)', value: 'L', score: 0.77 },
  { label: 'High (H)', value: 'H', score: 0.44 },
] as const;

export const PRIVILEGES_REQUIRED = [
  { label: 'None (N)', value: 'N', scoreUnchanged: 0.85, scoreChanged: 0.85 },
  { label: 'Low (L)', value: 'L', scoreUnchanged: 0.62, scoreChanged: 0.68 },
  { label: 'High (H)', value: 'H', scoreUnchanged: 0.27, scoreChanged: 0.5 },
] as const;

export const USER_INTERACTION = [
  { label: 'None (N)', value: 'N', score: 0.85 },
  { label: 'Required (R)', value: 'R', score: 0.62 },
] as const;

export const SCOPE = [
  { label: 'Unchanged (U)', value: 'U' },
  { label: 'Changed (C)', value: 'C' },
] as const;

export const IMPACT_METRICS = [
  { label: 'None (N)', value: 'N', score: 0 },
  { label: 'Low (L)', value: 'L', score: 0.22 },
  { label: 'High (H)', value: 'H', score: 0.56 },
] as const;
